import React from "react";

const LayOverModal = ({ isOpen, onClose, heading, content }) => {
  if (!isOpen) return null;

  // Inline styles
  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    content: {
      background: "white",
      padding: "20px",
      borderRadius: "10px",
      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      maxWidth: "400px",
      width: "90%",
      position: "relative",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "none",
      border: "none",
      fontSize: "1.5rem",
      cursor: "pointer",
    },
    heading: {
      fontSize: "18px",
      color: "#3C3C3C",
      fontWeight: "600",
      marginBottom: "10px",
    },
    paragraph: {
      marginBottom: "10px",
    },
    list: {
      listStyle: "disc",
      paddingLeft: "20px",
    },
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.content}>
        <button style={styles.closeButton} onClick={onClose}>
          &times;
        </button>
        <h2 style={styles.heading}>{heading}</h2>
        <div>{content}</div>
      </div>
    </div>
  );
};

export default LayOverModal;
